import { render, staticRenderFns } from "./ReportsSalesSectionView.vue?vue&type=template&id=ff8088d4"
import script from "./ReportsSalesSectionView.vue?vue&type=script&lang=js"
export * from "./ReportsSalesSectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports